export default "__VITE_ASSET__eb15bfbc__"